import {ICampaignStatusEnum} from '../../campaigns/interfaces/ICampaigns';
import OrderLists from '../components/list';

const OrderDraft = () => {
  return <OrderLists status={ICampaignStatusEnum.DRAFT} />;
};

export default OrderDraft;
